export const excludeItems = ['pageMenuItems', 'helpMenuItem'];
// Utility to find the path (array of menu item ids) from the root to the active menu item,
// given a menu structure and a pathname. Returns the deepest (longest) matching path.
// Skips menu items with url === '#', and ignores the 'pageMenuItems' key at the top level.
// If no match is found, returns an empty array.
function findActivePath(menuData, windowLocationPathname) {
    // Recursively search for a menu item whose url matches the pathname.
    // Returns the path of ids from the root to the matching item, or null if not found.
    function search(item, path) {
        if (!item || typeof item !== 'object') return null;
        // Check if this item matches the pathname (ignoring url === '#')
        if (item.url && item.url !== '#' && typeof item.url === 'string' && windowLocationPathname && windowLocationPathname.startsWith(item.url)) {
            // If there are subItems, search them for a deeper match
            if (item.subItems && Array.isArray(item.subItems)) {
                const found = item.subItems
                    .map((sub) => search(sub, [...path, item.id]))
                    .find(Boolean);
                if (found) return found;
            }
            // No deeper match, return this path
            if (!item.id) {
                return null; // Skip items without id
            }
            return [...path, item.id];
        }
        // If not a match, but has subItems, search them
        if (item.subItems && Array.isArray(item.subItems)) {
            const found = item.subItems
                .map((sub) => search(sub, [...path, item.id]))
                .find(Boolean);
            if (found) return found;
        }
        // No match found in this branch
        return null;
    }

    // Search all top-level menu items in menuData (except 'pageMenuItems')
    if (!menuData || typeof menuData !== 'object') return [];
    const candidates = [];
    Object.keys(menuData).forEach((key) => {
        if (excludeItems.includes(key)) return;
        const value = menuData[key];
        if (Array.isArray(value)) {
            value.forEach((item) => {
                const result = search(item, []);
                if (result) candidates.push(result);
            });
        } else if (value && typeof value === 'object') {
            const result = search(value, []);
            if (result) candidates.push(result);
        }
    });
    // Return the longest (deepest) matching path, or an empty array if none found
    if (candidates.length === 0) return [];
    return candidates.reduce((a, b) => (a.length >= b.length ? a : b));
}

export default findActivePath;
